import script from "./BaseListCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseListCard.vue?vue&type=script&setup=true&lang=js"

import "./BaseListCard.vue?vue&type=style&index=0&id=478e5080&lang=scss"

const __exports__ = script;

export default __exports__